import { API_ENDPOINT, STORAGE } from "../constants";
import { HTTP } from "./http";
import { StorageService } from "./storage";

export const ExpensesManagementService = {
  save: (
    name: string,
    category: string,
    _id?: string,
    // account?: string,
    status?: boolean,
  ) => {
    const { account } = StorageService.get(STORAGE.USER);
    return HTTP.post<any, any>(`${API_ENDPOINT}expenses-management`, { _id, account, name, category, status });
  },
  list: () => {
    const { account } = StorageService.get(STORAGE.USER);
    return HTTP.get<any, any>(`${API_ENDPOINT}expenses-management/${account}`);
  },
}